import { AIPowered, PrivacyIcon, RingIcon, StoriesIcon } from "assets/icons";
import "./style.scss";

function JourneyCards() {
  const cardData = [
    {
      icon: <PrivacyIcon />,
      text: "Private & secure communication",
    },
    {
      icon: <StoriesIcon />,
      text: "Success stories & community engagement",
    },
    {
      icon: <AIPowered />,
      text: "AI-powered match suggestions",
    },
    {
      icon: <RingIcon />,
      text: "Complete wedding solutions",
    },
  ];

  return (
    <div className="journey-cards-container">
      {cardData.map((item, index) => (
        <div className="journey-cards-wrapper" key={index}>
          <span>{item.icon}</span>
          <p className="card-content font-title-lg fw-700">{item.text}</p>
        </div>
      ))}
    </div>
  );
}

export default JourneyCards;
